import { useEffect } from 'react';
import { Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Box from '../../lib/appfuse-react/component/Box';

const useStyles = makeStyles((theme) => ({
  banner: {
    width: '100%',
    backgroundColor: 'transparent',
    [theme.breakpoints.down('sm')]: {
      height: 'fit-content',
    },
  },
  bannerFallback: {
    width: '100%',
    height: '200px',
    position: 'relative',
    backgroundImage: 'url(brand/Organization.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
    },
    [theme.breakpoints.down('sm')]: {
      height: '150px',
    },
  },
  bannerFallbackContent: {
    position: 'relative',
    zIndex: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
  },
  bannerLogo: {
    height: '60px',
    marginBottom: '12px',
    [theme.breakpoints.down('sm')]: {
      height: '45px',
      marginBottom: '8px',
    },
  },
  bannerTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#1A1A2E',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.1rem',
    },
  },
}));

/**
 * Shared Banner component for Main and Thank pages
 * Displays theme banner image or fallback with logo
 *
 * @param {Function} onLoad - Callback when banner image loads (optional)
 */
function Banner({ onLoad }) {
  const classes = useStyles();
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const src = smDown ? theme.brand.resumeBannerSm : theme.brand.resumeBanner;
  const hasImage = src && src.trim() !== '';

  useEffect(() => {
    if (!hasImage) {
      // No image configured, notify ready immediately
      onLoad?.();
      return;
    }

    const handleImageLoad = () => {
      onLoad?.();
    };

    const imageElement = document.getElementById('bannerImage');
    if (imageElement) {
      imageElement.addEventListener('load', handleImageLoad);
      return () => {
        imageElement.removeEventListener('load', handleImageLoad);
      };
    }
  }, [hasImage, onLoad]);

  // Render fallback banner if no image is configured
  if (!hasImage) {
    return (
      <Box className={classes.bannerFallback}>
        <Box className={classes.bannerFallbackContent}>
          <img src="brand/logo.svg" alt="Logo" className={classes.bannerLogo} />
          <Typography className={classes.bannerTitle}>
            好聘校園徵才簡歷填寫平台
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={classes.banner}>
      <img id="bannerImage" width="100%" height="auto" src={src} alt="Banner" />
    </Box>
  );
}

export default Banner;
